import React from 'react';
import { Link } from 'react-router-dom';
import { Translate as t } from '../../config/Translate';
import { formatDisplayDateTime } from '../../lib/dateDisplay';

const ServiceModalNewTicket = ({ alert, onClose }) => {
	if (!alert) return null;

	const labelStyle = {
		fontWeight: 600,
		color: '#495057',
		marginBottom: '2px',
		fontSize: '13px',
	};

	const valueStyle = {
		color: '#212529',
		fontSize: '14px',
		marginBottom: '12px',
	};

	return (
		<div style={{ padding: '16px' }}>
			<div style={{ marginBottom: '16px' }}>
				<div style={{
					display: 'inline-block',
					padding: '4px 10px',
					backgroundColor: '#0d6efd',
					color: '#fff',
					borderRadius: '4px',
					fontSize: '12px',
					fontWeight: 600,
				}}>
					{t('service.issueManager.newTicket')}
				</div>
			</div>

			<div style={labelStyle}>{t('service.issueManager.ticketKey')}</div>
			<div style={valueStyle}>
					{alert.ticketKey ? (
						<Link
							to={`/Admin/AdminService/${alert.ticketKey}`}
							onClick={onClose}
							style={{ color: '#0d6efd', textDecoration: 'none', fontWeight: 500 }}
						>
							{alert.ticketKey} <ion-icon name="open-outline" style={{ fontSize: '12px', verticalAlign: 'middle' }}></ion-icon>
						</Link>
					) : '-'}
				</div>

			<div style={labelStyle}>{t('service.issueManager.summary')}</div>
			<div style={valueStyle}>{alert.summary || '-'}</div>

			<div style={labelStyle}>{t('service.issueManager.company')}</div>
			<div style={valueStyle}>{alert.companyName || alert.companyId || '-'}</div>

			<div style={labelStyle}>{t('service.issueManager.creator')}</div>
			<div style={valueStyle}>{alert.creatorName || alert.creator || '-'}</div>

			<div style={labelStyle}>{t('service.issueManager.createdDate')}</div>
			<div style={valueStyle}>
				{alert.createDate ? formatDisplayDateTime(alert.createDate) : '-'}
			</div>

			<div style={{ textAlign: 'right', marginTop: '16px' }}>
				<button
					className="btn btn-secondary"
					onClick={onClose}
				>
					{t('common.button.close')}
				</button>
			</div>
		</div>
	);
};

export default ServiceModalNewTicket;
